import { useCallback } from 'react';
import styled from 'styled-components';
import DialogView from '../../../components/dialog-view/DialogView';
import { isDevice } from '../../../utils/device-handling/deviceDetectionUtils';
import { useNavigate } from '../../../hooks/useNavigate';
import MoveGoodsContent from './MoveGoodsContent';

interface Props {
  onClose?: () => void;
}

const MoveGoodsView = (props: Props) => {
  const { onClose } = props;
  const fullscreenTask = isDevice();
  const navigate = useNavigate();

  const handleCloseDialog = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  const handleCloseMove = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      {fullscreenTask ? (
        <StyledContent>
          <MoveGoodsContent onClose={handleCloseMove} />
        </StyledContent>
      ) : (
        <DialogView handleClose={handleCloseDialog}>
          <StyledDialogContent>
            <MoveGoodsContent onClose={handleCloseDialog} />
          </StyledDialogContent>
        </DialogView>
      )}
    </>
  );
};

const StyledDialogContent = styled.div`
  padding: 0;
  height: 90vh;
  width: 85vw;
  max-width: 1400px;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: 95vw;
  }
`;

const StyledContent = styled.div`
  height: 100vh;
  width: 100vw;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: start;
  overflow: hidden;
`;

export default MoveGoodsView;
